import { FC, useState } from "react";
import "./SidebarPlansFilter.scss";
import SidebarFilter from "../../../SidebarFilter/SidebarFilter";
import moment from "moment";
import { useForm } from "react-hook-form";
import { Col, FormGroup, Row } from "react-bootstrap";
import ReactSelect from "react-select";
import { typePlans } from "../../../../models/Financial/OptionsValues";
import { customStyles } from "../../../../models/SelectCustomStyles";
import { usePlans } from "../../../../providers/Financial/Plans/PlansProvider";

interface SidebarPlansFilterProps {}

// @ts-ignore
export const defaultValues = {
  id: null,
  name: "",
  description: "",
  plan_type: null,
} as any;

const SidebarPlansFilter: FC<SidebarPlansFilterProps> = () => {
  const [selectedTypePlans, setSelectedTypePlans] = useState<any | null>(null);

  const { handleSubmit, register, setValue } = useForm<any>({ defaultValues });
  const { setParams } = usePlans();

  const onSubmit = async (data: any) => {
    const {
      page: _page,
      perPage: _perPage,
      withPaginate: _withPaginate,
      ...rest
    } = data;

    const filter = {
      ...rest,
      id: data?.id,
      name: data?.name,
      description: data?.description,
      plan_type: data?.plan_type,
    };

    setParams((prev: any) => ({
      ...prev,
      filter: { ...(prev?.filter ?? {}), ...filter },
      page: 1,
      perPage: prev?.perPage ?? 10,
      withPaginate: prev?.withPaginate ?? true,
    }));
  };

  return (
    <SidebarFilter handleSubmit={handleSubmit(onSubmit)}>
      <div className="SidebarPlansFilter" data-testid="SidebarPlansFilter">
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="id">ID</label>
              <input className="form-control" {...register("id")} />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="name">NOME</label>
              <input className="form-control" {...register("name")} />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="description">DESCRIÇÃO</label>
              <input className="form-control" {...register("description")} />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="plan_type">Tipo do plano</label>
              <ReactSelect
                isSearchable
                options={typePlans}
                value={selectedTypePlans ?? ""}
                defaultValue={selectedTypePlans}
                placeholder="Selecione..."
                className={`form-control p-0`}
                noOptionsMessage={() => "Não há registros"}
                styles={customStyles}
                onChange={(val: any) => {
                  setValue("plan_type", val?.value);
                  setSelectedTypePlans(val);
                }}
              />
            </FormGroup>
          </Col>
        </Row>
      </div>
    </SidebarFilter>
  );
};

export default SidebarPlansFilter;
